import { useCallback, useState } from "react";
import { exportAnalyticsCsv } from "../../../api";
import { AnalyticsTab } from "../types";

interface ExportArgs {
    tab: AnalyticsTab;
    ids: string[];
    startDate: Date;
    endDate: Date;
}

interface UseExportCsv {
    exporting: boolean;
    error: string | null;
    run: (args: ExportArgs) => Promise<void>;
}

export const useExportCsv = (): UseExportCsv => {
    const [exporting, setExporting] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const run = useCallback(async ({ tab, ids, startDate, endDate }: ExportArgs) => {
        const token = localStorage.getItem("token");
        if (!token) {
            setError("missing-token");
            return;
        }
        setExporting(true);
        setError(null);
        try {
            await exportAnalyticsCsv({ token, tab, ids, startDate, endDate });
        } catch (e: any) {
            setError(e?.message || "unknown-error");
        } finally {
            setExporting(false);
        }
    }, []);

    return { exporting, error, run };
};
